module.exports = __webpack_public_path__ + "bfa740ea34624cca8944abb4cae39ce1.fbx";